interface Item{status:boolean, container:HTMLElement, btn:HTMLElement, iconWrapper:HTMLElement, iconLine1:HTMLElement, iconLine2:HTMLElement}

export default class Accordion {

private element:Item[] = [];
    

public constructor(){

    let accordions = document.querySelectorAll('.accordion');
    


    accordions.forEach(element => {


    this.element.push({
        status:false,
        container: element.querySelector('.accordion-container') as HTMLElement,
        btn: element.querySelector('.accordion-action') as HTMLElement,
        iconWrapper: document.createElement('div'),
        iconLine1: document.createElement('div'),
        iconLine2: document.createElement('div')
    });

});

for (let i:number = 0; i < this.element.length; i++){
    
    
    this.element[i].container.style.display = 'flex';
    this.element[i].container.style.overflow = 'hidden'; 
    this.element[i].container.style.height = '0px';
    this.element[i].container.style.transition = 'all 0.3s ease-in-out'; 


    this.element[i].btn.style.display = 'block';
    this.element[i].btn.style.position = 'relative';
    this.element[i].btn.style.width = '100%';
    this.element[i].btn.style.textAlign = 'left';
    this.element[i].btn.style.padding = '10px 20px 10px 60px';
    this.element[i].btn.style.marginTop = '0px';
    this.element[i].btn.style.cursor = 'pointer';
    this.element[i].btn.style.setProperty("font-size", "1.5rem", "important");


    
    this.element[i].iconWrapper.style.display = 'block';
    this.element[i].iconWrapper.style.width = '20px';
    this.element[i].iconWrapper.style.height= '20px';
    this.element[i].iconWrapper.style.background = 'none';
    this.element[i].iconWrapper.style.position = 'absolute';
    this.element[i].iconWrapper.style.top = '18px';
    this.element[i].iconWrapper.style.left = '20px';

    
    this.element[i].iconLine1.style.display = 'block';
    this.element[i].iconLine1.style.width = '20px';
    this.element[i].iconLine1.style.height= '4px';
    this.element[i].iconLine1.style.background = '#555';
    this.element[i].iconLine1.style.position = 'absolute';
    this.element[i].iconLine1.style.top = '8px';
    this.element[i].iconLine1.style.left = '0';

    
    this.element[i].iconLine2.style.display = 'block';
    this.element[i].iconLine2.style.width = '20px';
    this.element[i].iconLine2.style.height= '4px';
    this.element[i].iconLine2.style.background = '#555';
    this.element[i].iconLine2.style.position = 'absolute';
    this.element[i].iconLine2.style.top = '8px';
    this.element[i].iconLine2.style.left = '0';
    this.element[i].iconLine2.style.transition = 'all 0.15s linear';
    this.element[i].iconLine2.style.transform = 'rotate(90deg)';


    this.element[i].iconWrapper.append(this.element[i].iconLine1);
    this.element[i].iconWrapper.append(this.element[i].iconLine2);


    this.element[i].btn.append(this.element[i].iconWrapper);


    this.element[i].btn.addEventListener('click', e=>{

        if(this.element[i].status == false){


            this.element.forEach(ele => {
                
                ele.status = false;
                ele.container.style.height = '0px';
                ele.container.classList.add('accordions-close');
                ele.iconLine2.style.transform = 'rotate(90deg)';

            });

            this.element[i].status = true;
            this.element[i].container.style.height = 'auto';
            this.element[i].container.classList.remove('accordions-close');
            this.element[i].iconLine2.style.transform = 'rotate(0deg)';

        }else{

            this.element[i].status = false;
            this.element[i].container.style.height = '0px';
            this.element[i].container.classList.add('accordions-close');
            this.element[i].iconLine2.style.transform = 'rotate(90deg)';

        }

    });
 
}


    //let accordion-action
    //let accordion-container

}





}